<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_passbook"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Pass <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-select label="Template"
                                             multiple="false"
                                             v-model="resource.template"
                                             :default="resource.template_id"
                                             :options="templates"
                                             :callback="setTemplate"
                                             v-if="templates"></form-select>

                                <div v-for="index in resource.template.values" v-if="resource.template && resource.template.values">
                                    <form-text :label="index" v-model="resource.values[index]"></form-text>
                                </div>

                            </tab>
                            <tab name="Preview">

                                <div style="text-align: center;">
                                    <iframe :src="resource.preview_url" width="340" height="420" allowtransparency="true" frameborder="0"></iframe>
                                </div>

                            </tab>
                        </tabs>

                    </main>
                    <footer>

                    </footer>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import ScopeService from '../scope/ScopeService.js';
    import PassService from './PassService.js';
    import PassTemplateService from './PassTemplateService.js';
    import Edit from '../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                templates: []
            }
        },
        mounted: function(){
            PassTemplateService.query().then(response => {
                this.templates = response.data.data
                this.isLoading = false
            })
        },
        methods:{
            resourceLoaded: function(){
                this.resource.scope = this.resource.scope ? this.resource.scope : {}
                this.resource.template = this.resource.template ? this.resource.template : {}
                this.resource.values = this.resource.values ? this.resource.values : {};
                this.initialize()
            },
            getResource: function(){
                return PassService
            },
            setTemplate: function(args){
                this.resource.template_id = args.id
                this.resource.template = args
                this.$forceUpdate();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/pass/Edit.vue